__turbopack_context__.v({
  "className": "brandserif_5b16351-module__vGVGHa__className",
  "variable": "brandserif_5b16351-module__vGVGHa__variable",
});
